const cardItems = [
  {
    id: 1,
    title: '某知名导演新片片场争议始末，多位演员发声回应',
    excerpt: '近日备受关注的新片拍摄现场引发多方讨论，业内人士纷纷表态。',
    category: '影视吃瓜',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20film%20set%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20movie%20production%20aesthetic%2C%20dark%20background%20with%20amber%20glow%2C%20entertainment%20industry%20visual%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-1-51hl&orientation=landscape',
    time: '3小时前',
    hot: true,
  },
  {
    id: 2,
    title: '某综艺节目幕后黑幕大揭秘：剪辑套路知多少',
    excerpt: '资深从业者爆料综艺节目不为人知的剪辑手法和制造话题的内幕操作。',
    category: '综艺揭秘',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20studio%20production%20behind%20scenes%20atmosphere%2C%20dark%20space%20with%20warm%20glowing%20lights%2C%20entertainment%20production%20set%2C%20dramatic%20cinematic%20mood%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-2-51hl&orientation=landscape',
    time: '5小时前',
    hot: true,
  },
  {
    id: 3,
    title: '两位一线明星社交媒体互怼，粉丝站队火药味十足',
    excerpt: '某社交平台上两位顶流艺人隔空交锋，双方粉丝阵营激烈对线。',
    category: '明星动态',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20conflict%20visual%20with%20split%20composition%2C%20warm%20versus%20cool%20tones%20clashing%2C%20dramatic%20energy%2C%20digital%20war%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-3-51hl&orientation=landscape',
    time: '6小时前',
    hot: false,
  },
  {
    id: 4,
    title: '某品牌公关危机全纪录：从翻车到道歉完整时间线',
    excerpt: '知名品牌因代言人言论引发连锁反应，公关团队的应对引发行业讨论。',
    category: '商业吃瓜',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20crisis%20management%20visual%20with%20dark%20office%20atmosphere%2C%20dramatic%20lighting%2C%20business%20tension%2C%20warm%20amber%20accents%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-4-51hl&orientation=landscape',
    time: '9小时前',
    hot: false,
  },
  {
    id: 5,
    title: '热门网剧第二季官宣阵容，换角风波引老粉不满',
    excerpt: '备受期待的续作公布全新演员阵容，部分角色更换引发粉丝强烈反应。',
    category: '影视动态',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20drama%20series%20announcement%20visual%20with%20spotlight%20effect%2C%20theatrical%20atmosphere%2C%20warm%20golden%20and%20dark%20tones%2C%20entertainment%20industry%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-5-51hl&orientation=landscape',
    time: '11小时前',
    hot: true,
  },
  {
    id: 6,
    title: '年度音乐盛典获奖名单提前泄露，争议奖项引热议',
    excerpt: '即将举办的音乐颁奖礼完整名单在网络流传，多个奖项选择引发质疑。',
    category: '音乐吃瓜',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20award%20ceremony%20atmosphere%20with%20golden%20spotlights%2C%20elegant%20dark%20background%2C%20stage%20lighting%20effects%2C%20prestigious%20event%20visual%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-6-51hl&orientation=landscape',
    time: '14小时前',
    hot: false,
  },
  {
    id: 7,
    title: '短视频平台网红人设崩塌事件深度复盘',
    excerpt: '拥有千万粉丝的短视频创作者因过往言论被扒，精心打造的人设一夜瓦解。',
    category: '网红翻车',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20influencer%20downfall%20visual%20with%20shattered%20glass%20effect%2C%20dramatic%20dark%20background%20with%20warm%20accents%2C%20digital%20era%20aesthetic%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=card-7-51hl&orientation=landscape',
    time: '16小时前',
    hot: true,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            精选全网最值得关注的黑料视频与吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[16/10] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
                {item.hot && (
                  <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-md font-medium">
                    热门
                  </span>
                )}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-800 px-2 py-0.5 rounded-md font-medium">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}